/* global jQuery */
/* global require */
angular.module('app.employee', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging', 'uiGmapgoogle-maps'])
    .config(['$routeProvider', ($routeProvider) => {
      $routeProvider.when('/employees', {
        template: require('./employees.html'),
        controller: 'employeeListCtrl',
      })
        .when('/employees/teams', {
          template: require('./teams.html'),
          controller: 'teamListCtrl',
        })
        .when('/employees/teams/:tb_team_id', {
          template: require('./team.html'),
          controller: 'teamViewCtrl',
        });
    }])
    .controller('employeeListCtrl', ($rootScope, $translate, $scope, $resource, $route, $location, $cookies, $window, $timeout, AuthService, envService) => {
      $rootScope.mainmenu = 'members';
      $rootScope.menu = 'employees';
      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }
      $scope.total_count = 0;
      $scope.activeYN = '-1';
      $resource(`${APIURL}/admin/employees`).get((data) => {
        $scope.users = data.users;
        $scope.total_count = data.total_count;
        $scope.online_count = data.online_count;
        $scope.offline_count = data.offline_count;
        console.log(data);
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });

      $scope.paging = (page) => {
        $resource(`${APIURL}/admin/employees`).get({ page: page - 1, active_yn: $scope.activeYN },
                (data) => {
                  $scope.users = data.users;
                }, (err) => {
                  console.error(err);
                  if (err.data && err.data.msg) {
                    alert(err.data.msg);
                  } else {
                    alert($translate.instant('알수 없는 에러 입니다.'));
                  }
                });
      };
      $scope.view = (user) => {
        $resource(`${APIURL}/admin/employees/:tb_user_id`, { tb_user_id: user.ID }).get((data) => {
          console.log(data);
          $scope.user = data.employee;
          jQuery('#modal-view').modal('show');
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      $scope.delete = (user) => {
        if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
          return;
        }
        $resource(`${APIURL}/admin/employees/:tb_user_id`, { tb_user_id: user.ID }).delete(
            () => {
              alert($translate.instant('삭제되었습니다'));
              $scope.users.splice($scope.users.indexOf(user), 1);
              jQuery('#modal-view').modal('hide');
            }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      $scope.edit = (user) => {
        jQuery('#modal-view').removeClass('fade');
        jQuery('#modal-view').modal('hide');
        $location.path(`/employees/${user.ID}`);
      };

      $scope.revertActive = (user) => {
        const activeYN = user.ACTIVEYN === 'Y' ? 'N' : 'Y';
        $resource(`${APIURL}/admin/employees/:tb_user_id/active`, { tb_user_id: user.ID }).save({ ACTIVEYN: activeYN },
          () => {
            alert($translate.instant('수정되었습니다.'));
            user.ACTIVEYN = activeYN;
            // window.location.reload();                        
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));              
            }
          });
      };
    })
    .controller('teamListCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $window, AuthService, envService) => {
      $rootScope.mainmenu = 'members';
      $rootScope.menu = 'teams';
      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }
      $scope.total_count = 0;
      $resource(`${APIURL}/admin/employees/teams`).get((data) => {
        $scope.teams = data.teams;
        $scope.total_count = data.total_count;
        console.log(data);
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });

      $scope.paging = (page) => {
        console.log(`targetpage = ${page}`);
        $resource(`${APIURL}/admin/employees/teams`).get({ page: page - 1 },
                (data) => {
                  $scope.teams = data.teams;
                  $scope.total_count = data.total_count;
                }, (err) => {
                  console.error(err);
                  if (err.data && err.data.msg) {
                    alert(err.data.msg);
                  } else {
                    alert($translate.instant('알수 없는 에러 입니다.'));
                  }
                });
      };

      $scope.showTeamAddPopup = () => {
        $scope.showAddForm = false;
        $scope.showAddWithEmployee = false;
        $scope.searchingForAdd = false;
        $resource(`${APIURL}/admin/employees/teamable`).get((data) => {
          $scope.results = data.employees;
          $scope.searchingForAdd = true;
          jQuery('#modal-add').modal('show');
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };

      $scope.queryTeamAddEmployee = () => {
        $resource(`${APIURL}/admin/employees/teamable`).get({ q: $scope.query }, (data) => {
          $scope.results = data.employees;
          $scope.searchingForAdd = true;
          jQuery('#modal-add').modal('show');
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      $scope.selectForAdd = (user) => {
        $scope.searchingForAdd = false;
        $scope.showAddWithEmployee = true;
        $scope.selectedUser = user;
        $scope.selectedUser.COMMISION = 10;
      };

      $scope.create = () => {
        if (isNaN(parseInt($scope.selectedUser.COMMISION, 10))) {
          alert($translate.instant('올바른 수익율을 입력해주세요. (0~20)'));
          return;
        }
        if (parseInt($scope.selectedUser.COMMISION, 10) < 0 || parseInt($scope.selectedUser.COMMISION, 10) > 20) {
          alert($translate.instant('올바른 수익율을 입력해주세요. (0~20)'));
          return;
        }
        $resource(`${APIURL}/admin/employees/teams`).save($scope.selectedUser, () => {
          $window.location.reload();
        },
              (err) => {
                console.error(err);
                if (err.data && err.data.msg) {
                  alert(err.data.msg);
                } else {
                  alert($translate.instant('알수 없는 에러 입니다.'));
                }
              },
            );
      };

      $scope.deleteTeam = (team) => {
        if (!team || !team.ID) {
          return;
        }
        if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
          return;
        }
        $resource(`${APIURL}/admin/employees/teams/${team.ID}`).delete(() => {
          $scope.paging(1);
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
    })
    .controller('teamViewCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService) => {
      $rootScope.mainmenu = 'members';
      $rootScope.menu = 'teams';
      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }
      $scope.tb_team_id = $routeParams.tb_team_id;
      $scope.total_count = 0;
      $resource(`${APIURL}/admin/employees/teams/${$scope.tb_team_id}`).get((data) => {
        $scope.team = data.team;
        $scope.members = data.members;
        $scope.total_count = data.total_count;
        console.log(data);
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
      $scope.paging = (page) => {
        console.log(`targetpage = ${page}`);
        $resource(`${APIURL}/admin/employees/teams/${$scope.tb_team_id}`).get({ page: page - 1 },
                (data) => {
                  $scope.members = data.members;
                }, (err) => {
                  console.error(err);
                  if (err.data && err.data.msg) {
                    alert(err.data.msg);
                  } else {
                    alert($translate.instant('알수 없는 에러 입니다.'));
                  }
                });
      };
      $scope.deleteTeam = () => {
        if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
          return;
        }
        $resource(`${APIURL}/admin/employees/teams/${$scope.tb_team_id}`).delete(() => {
          $location.path('/employees/teams');
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
    })
    .controller('employeeEditCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService, uiGmapGoogleMapApi, Upload) => {
      $rootScope.mainmenu = 'members';
      $rootScope.menu = 'employees';
      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }

      $scope.is_editing = true;

      $resource(`${APIURL}/admin/employees/:tb_user_id`, { tb_user_id: $routeParams.tb_user_id }).get((data) => {
        console.log(data);
        $scope.detailer = $scope.keysToLowerCase(data.employee);
        $scope.detailer.type = $scope.detailer.employee_type;
        if ($scope.detailer.type === undefined || $scope.detailer.type === null) {
          $scope.detailer.type = '1';
        }
        if ($scope.detailer.tb_team_id === undefined || $scope.detailer.tb_team_id === null) {
          $scope.detailer.tb_team_id = '-1';
        } else {
          $scope.detailer.tb_team_id = $scope.detailer.tb_team_id.toString();
        }
        if ($scope.detailer.tb_city_id === undefined || $scope.detailer.tb_city_id === null) {
          $scope.detailer.tb_city_id = '1';
        } else {
          $scope.detailer.tb_city_id = $scope.detailer.tb_city_id.toString();
        }
        $resource(`${APIURL}/admin/meta/employee`).get({ TB_USER_ID: $routeParams.tb_user_id, TB_CITY_ID: $scope.detailer.tb_city_id }, (meta) => {
          $scope.teams = meta.teams;
          $scope.cities = meta.cities;
          $scope.requestAreas();
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });


      $scope.detailer = { name: '', id: '', password: '', email: '', tel: '', profile_image: '', type: '1', tb_team_id: '-1' };
      $scope.submit = () => {
        if ($scope.detailer.profile_image.length < 1) {
          alert($translate.instant('프로필 이미지를 등록 해주세요.'));
          return;
        }
        if ($scope.detailer.name.length < 1) {
          alert($translate.instant('이름을 입력해 주세요.'));
          return;
        }
        if ($scope.detailer.email.length < 1) {
          alert($translate.instant('이메일을 입력해 주세요.'));
          return;
        }
        if ($scope.detailer.id === undefined && $scope.detailer.password.length < 1) {
          alert($translate.instant('비밀번호를 입력해주세요.'));
          return;
        }
        if ($scope.detailer.tel.length < 1) {
          alert($translate.instant('전화번호를 입력해주세요.'));
          return;
        }
        if ($scope.detailer.gender === undefined || $scope.detailer.gender === null || $scope.detailer.gender.length < 1) {
          alert($translate.instant('성별을 선택해주세요.'));
          return;
        }
        if ($scope.detailer.birth === undefined || $scope.detailer.birth === null || $scope.detailer.birth.length < 1) {
          alert($translate.instant('생년월일을 입력해주세요'));
          return;
        }
        if ($scope.detailer.working_hour === undefined || $scope.detailer.working_hour === null || $scope.detailer.working_hour.legnth < 1) {
          alert($translate.instant('세차가능시간을 입력해주세요.'));
          return;
        }
        if ($scope.detailer.vehicle === undefined || $scope.detailer.vehicle === null || $scope.detailer.vehicle.legnth < 1) {
          alert($translate.instant('이동수단을 입력해주세요.'));
          return;
        }
        if ($scope.detailer.commission.length < 1) {
          alert($translate.instant('수익율을 입력해주세요.'));
          return;
        }
        if (isNaN(parseInt($scope.detailer.commission, 10)) || parseInt($scope.detailer.commission, 10) < 0 || parseInt($scope.detailer.commission, 10) > 100) {
          alert($translate.instant('올바른 수익율을 입력해주세요(0~100)'));
          return;
        }
        $scope.detailer.areas = [];
        if ($scope.areas) {
          for (let idx = 0; idx < $scope.areas.length; idx += 1) {
            const area = $scope.areas[idx];
            if (area.enabled === true) {
              $scope.detailer.areas.push(area.ID);
            }
          }
        }
        if ($scope.detailer.areas.length < 1) {
          if (!confirm($translate.instant('설정된 지역구가 없습니다. 그래도 수정하시겠습니까?'))) {
            return;
          }
        }
        let requestPath = `${APIURL}/admin/employees`;
        if ($scope.detailer.id !== undefined) {
          requestPath = `${APIURL}/admin/employees/${$scope.detailer.id}`;
        }
        console.log($scope.detailer);
        $resource(requestPath).save($scope.detailer, (data) => {
          console.log(data);
          $location.path('/employees');
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };

      $scope.upload = (files) => {
        console.log(files);
        if (files && files.length) {
          const file = files[0];
          Upload.upload({
            url: `${APIURL}/admin/file/profile`,
            file,
          }).progress(() => {
          }).success((data, status, headers, config) => {
            console.log(`file ${config.file.name}uploaded. Response: ${data}`);
            console.log(data);
            $scope.detailer.profile_image = data.url;
          });
        }
      };

      $scope.requestAreas = () => {
        $resource(`${APIURL}/admin/maps/areas/foremployee`).get({ TB_USER_ID: $routeParams.tb_user_id }, (data) => {
          $scope.areas = data.areas;
          if ($scope.areas) {
            for (let idx = 0; idx < $scope.areas.length; idx += 1) {
              const area = $scope.areas[idx];
              area.enabled = area.enabled == 1; // eslint-disable-line eqeqeq
            }
          }
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      $scope.keysToLowerCase = (obj) => {
        Object.keys(obj).forEach((key) => {
          const k = key.toLowerCase();

          if (k !== key) {
            obj[k] = obj[key];
            delete obj[key];
          }
        });
        return (obj);
      };
    });



// WEBPACK FOOTER //
// ./src/app/employee/employee.js